import { styled } from "styled-components";

const Subtitle = styled.h4`
  font-size: 16px;
  color: ${(props) => props.theme.colors.darkColor};
  letter-spacing: 0.32px;
  margin: 0;
  margin-bottom: 12px;
  text-indent: 0px;
`;

export default Subtitle;
